import React, { useState } from "react";
import { Input, DialogModalWindow } from './';
import { LabeledContainer } from "../layout";
import { accountApi } from '../../api/AccountApi';
import './NameDialog.scss';

const NameDialog = ({ isOpen, onCancel, onSaveName }) => {

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");

    const onSave = (firstName, lastName) => {
        accountApi.update({ first_name: firstName, last_name: lastName });
        onSaveName();
    }

    return (
        <DialogModalWindow
            isOpen={false}
            onCancel={onCancel}
            cancelBtn={false}
            confirmBtn={false}
        >
            <div className="name-dialog-body">
                <h1>Almost there! Tell us your name.</h1>
                <p>Your participants will want to know who's asking them a Question.</p>

                <div className="col-sm text-left name-form">
                    <LabeledContainer
                        titleWarning={false}
                        title={'First name:'}
                        className="mb-3"
                    >
                        <Input
                            name="firstName"
                            size="30"
                            placeholder={''}
                            value={firstName}
                            onChange={e => setFirstName(e.target.value)}
                            autoComplete="off"
                        />
                    </LabeledContainer>
                    <LabeledContainer
                        titleWarning={false}
                        title={'Last name:'}
                        className="mb-3"
                    >
                        <Input
                            name="lastName"
                            size="30"
                            placeholder={''}
                            value={lastName}
                            onChange={e => setLastName(e.target.value)}
                            autoComplete="off"
                        />
                    </LabeledContainer>
                </div>
                <button
                    className="btn-submit"
                    onClick={() => onSave(firstName, lastName)}
                    disabled={firstName.trim() == "" || lastName.trim() == ""}
                >
                    Next
                </button>
            </div>
        </DialogModalWindow>
    );
};

export default NameDialog;